import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDevices, useDaily } from '@daily-co/daily-react';
import { pageAtom, topMessageAtom } from '../../State';
import { useSetRecoilState } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeWhiteButton.svg';
import DataModel from '../Util/DataModel';
import { ReactComponent as FacelessBoySVG } from '../Images/buttons/electronTopBottom.svg';
import { getAuth, sendSignInLinkToEmail, signInWithCustomToken } from 'firebase/auth';
import { ReactComponent as LogoSVG } from '../Images/header/logoBlack.svg';
import { useTranslation } from 'react-i18next';
export default function ElectronEmail() {
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [emailState, setEmailState] = useState('');
  const [codeState, setCodeState] = useState('');
  const [isSendingState, setIsSendingState] = useState(false);
  const [loginStatusState, setLoginStatusState] = useState('typeEmail');
  const { t, i18n } = useTranslation();

  const handleChange = (event) => {
    setEmailState(event.target.value);
  };

  const handleCode = (event) => {
    setCodeState(event.target.value);
  };

  const editEmail = () => {
    setLoginStatusState('typeEmail');
  };

  const tapSend = async () => {
    if (emailState != '' && isSendingState == false) {
      //送信中フラグオン
      setIsSendingState(true);

      //許可リストを確認
      let allowResult = await checkAllowList();

      // console.log(allowResult)
      // alert(allowResult)

      if (allowResult == false) {
        alert(t('mypage.Your email is not registered in our allow list'));
        setIsSendingState(false);
        return;
      }

      //メール送信
      const result = await DataModel.mailLogin(emailState, i18n.language);

      //送信中フラグオフ
      setIsSendingState(false);

      if (result != null) {
        setTopMessageState({
          type: 'joined',
          message: t('mypage.Email sent successfully'),
        });

        //コード入力画面へ
        setLoginStatusState('typeCode');
      } else {
        setTopMessageState({
          type: 'joined',
          message: t('mypage.Error something wrong'),
        });
      }
    }
  };

  async function checkAllowList(type = 'email', code = null) {
    const result = await DataModel.checkAllowList(emailState, type, code);
    return result;
  }

  //コード送信ボタンをタップ
  const tapCode = async () => {
    if (codeState != '' && isSendingState == false) {
      //送信中フラグオン
      setIsSendingState(true);

      //コードの確認
      const result = await DataModel.checkEmailCode(emailState, codeState, i18n.language);

      if (result != null) {
        //ログイン処理
        const auth = getAuth();

        //ミーティングIDをローカルに保存
        localStorage.setItem('meetingID', result.meetingID);

        //トークンでのログイン
        signInWithCustomToken(auth, result.token)
          .then((result) => {
            console.log('ログインした');

            //送信中フラグオフ
            setIsSendingState(false);

            setTopMessageState({
              type: 'joined',
              message: t('mypage.Logged in!'),
            });
          })
          .catch((error) => {
            console.log('エラーだよ');
            console.log(error);
          });
      } else {
        //送信中フラグオフ
        setIsSendingState(false);

        //エラーメッセージ
        setTopMessageState({
          type: 'joined',
          message: t('mypage.Error something wrong'),
        });
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key !== 'Enter') return;

    if (loginStatusState == 'typeEmail') {
      tapSend();
    } else {
      tapCode();
    }
  };

  //レンダー
  return (
    <>
      <div id="electronEmailWrap">
        <div id="electronHeader">
          <div id="electronHeaderImage">
            <LogoSVG />
          </div>
        </div>
        <div id="electronEmailInside">
          {/*メール入力画面 */}
          {loginStatusState == 'typeEmail' ? (
            <>
              <h1>{t('mypage.Sign Up / Login')} </h1>
              <input
                id="electronEmailInput"
                name="email"
                type="text"
                placeholder={t('mypage.Enter your email address')}
                onChange={(e) => handleChange(e)}
                value={emailState}
                onKeyDown={handleKeyDown}
              />
              <button disabled={emailState != '' ? false : true} onClick={tapSend}>
                {isSendingState ? (
                  <>
                    <div id="selectLoader">
                      <svg className="circular-loader" viewBox="25 25 50 50">
                        <circle
                          className="loader-path"
                          cx="50"
                          cy="50"
                          r="20"
                          fill="none"
                          stroke="#70c542"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                  </>
                ) : (
                  <>{t('mypage.Send')}</>
                )}
              </button>

              <div id="electronEmailTerm">
                <>{t("mypage.By clicking on 'Send' button, you agree with the")}</>
                <a href="https://faceless.ooo/terms" target="_blank">
                  {t('mypage.Terms')}
                </a>
              </div>
            </>
          ) : (
            <>
              {/*コード入力 */}
              <h1> {t('mypage.Type Code')}</h1>
              <div id="codeDetail">
                {t('mypage.Please check your mail box...')}
                <span id="editEmail" onClick={editEmail}>
                  {t('mypage.change my email.')}
                </span>
              </div>
              <input
                id="electronEmailInput"
                name="email"
                type="text"
                placeholder={t('mypage.Type Code')}
                onChange={(e) => handleCode(e)}
                value={codeState}
                onKeyDown={handleKeyDown}
              />
              <button disabled={codeState != '' ? false : true} onClick={tapCode}>
                {isSendingState ? (
                  <>
                    <div id="selectLoader">
                      <svg className="circular-loader" viewBox="25 25 50 50">
                        <circle
                          className="loader-path"
                          cx="50"
                          cy="50"
                          r="20"
                          fill="none"
                          stroke="#70c542"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                  </>
                ) : (
                  <>{t('mypage.Send')}</>
                )}
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
